var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _g, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSymbolHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 200,
    viewBox: "0 0 82 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.4771,
    y: 7.32605,
    width: 13.211,
    height: 185.348,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.4771,
    y: 7.32605,
    width: 13.211,
    height: 185.348,
    fill: "url(#paint0_linear_255_1006)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.4771,
    y: 7.32605,
    width: 13.211,
    height: 185.348,
    fill: "url(#paint1_linear_255_1006)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.688,
    width: 28.6239,
    height: 185.348,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26.688,
    width: 28.6239,
    height: 185.348,
    fill: "url(#paint2_linear_255_1006)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26.688,
    width: 28.6239,
    height: 185.348,
    fill: "url(#paint3_linear_255_1006)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 55.312,
    y: 14.6521,
    width: 13.211,
    height: 185.348,
    fill: "url(#paint4_linear_255_1006)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 55.312,
    y: 14.6521,
    width: 13.211,
    height: 185.348,
    fill: "url(#paint5_linear_255_1006)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_255_1006",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 65,
    width: 80,
    height: 69
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9821 77.5859C43.5969 74.7465 45.356 72.5696 47.3527 70.6767C54.9594 63.5308 66.3693 63.3888 74.2612 70.2508C81.963 76.9234 83.2466 88.5177 77.1613 96.9413C76.876 97.3199 76.6383 97.7458 76.258 98.0771C64.5152 109.624 52.7725 121.171 40.4117 133.333C38.1772 130.825 35.8477 128.08 33.328 125.525C24.6754 116.817 15.8802 108.299 7.27518 99.5441C1.52265 93.676 -0.56917 86.6248 2.23578 78.7217C5.04073 70.724 10.9834 66.2756 19.3983 65.3291C25.1984 64.6666 30.3804 66.6068 34.6116 70.582C36.7034 72.5223 38.51 74.7938 40.9821 77.5859Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_255_1006)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6.33936,
    y: 51.282,
    width: 33.0275,
    height: 95.9707,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -6.33936,
    y: 51.282,
    width: 33.0275,
    height: 95.9707,
    fill: "url(#paint6_linear_255_1006)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.688,
    y: 51.282,
    width: 28.6238,
    height: 95.9707,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.688,
    y: 51.282,
    width: 28.6238,
    height: 95.9707,
    fill: "url(#paint7_linear_255_1006)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.312,
    y: 62.2711,
    width: 32.2936,
    height: 93.0403,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.312,
    y: 62.2711,
    width: 32.2936,
    height: 93.0403,
    fill: "url(#paint8_linear_255_1006)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0104 70.3123L47.0087 70.3138C45.7029 71.5517 44.4874 72.921 43.0881 74.4973C42.4374 75.2303 41.747 76.0081 40.9893 76.8382C40.4605 76.2361 39.9592 75.6561 39.4759 75.0969C37.8869 73.2583 36.4928 71.6451 34.9529 70.2166C30.6251 66.1512 25.3008 64.1517 19.3419 64.8323C15.0603 65.3139 11.3803 66.6901 8.40774 68.9854C5.43402 71.2816 3.19463 74.4774 1.76427 78.5553C-1.11264 86.6621 1.05084 93.909 6.91812 99.8942L6.91858 99.8946C11.7577 104.818 16.6652 109.675 21.5707 114.53C25.3836 118.303 29.1952 122.075 32.9728 125.877C34.8744 127.806 36.6643 129.839 38.3974 131.809C38.9495 132.436 39.4959 133.057 40.0383 133.666L40.3878 134.058L40.7623 133.69C53.1091 121.541 64.8393 110.007 76.5687 98.4728L76.5983 98.4437C76.8232 98.2456 76.9994 98.0267 77.149 97.8219C77.2247 97.7184 77.2971 97.6133 77.3639 97.5173C77.4322 97.419 77.4957 97.3284 77.5606 97.2422L77.5607 97.2423L77.5666 97.2341C83.7998 88.6058 82.4909 76.7198 74.5893 69.8734C66.5067 62.8457 54.807 62.9879 47.0104 70.3123Z",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_255_1006",
    x1: 20.0826,
    y1: 32.9671,
    x2: 20.4326,
    y2: 193.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21D8D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_255_1006",
    x1: 20.0826,
    y1: 7.32605,
    x2: 20.0826,
    y2: 192.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#21D8D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#0000C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_255_1006",
    x1: 41.3669,
    y1: 26.7399,
    x2: 41.0012,
    y2: 168.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41F2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_255_1006",
    x1: 40.9999,
    y1: -5.39434e-9,
    x2: 40.8352,
    y2: 185.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.563944,
    stopColor: "#21D8D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#0000C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_255_1006",
    x1: 62.3106,
    y1: 25.6411,
    x2: 62.0881,
    y2: 163.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#41F2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_255_1006",
    x1: 61.9175,
    y1: 14.6521,
    x2: 61.9175,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.355231,
    stopColor: "#21D8D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.840885,
    stopColor: "#0000C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_255_1006",
    x1: 10.1744,
    y1: 102.054,
    x2: 10.1744,
    y2: 144.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21D8D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_255_1006",
    x1: 40.9999,
    y1: 87.9194,
    x2: 40.9999,
    y2: 147.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21D8D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_255_1006",
    x1: 71.4588,
    y1: 62.2711,
    x2: 71.4588,
    y2: 155.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21D8D9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolHeart);
export default __webpack_public_path__ + "static/media/symbol-heart.e18ae983a279cd970b127def8bbfb754.svg";
export { ForwardRef as ReactComponent };